import React, { useEffect, useState } from 'react'
import usePageTitle from '../hooks/usePageTitle'
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { ENDPOINT_INVITATIONS_EXCLUDE_REMINDER, ENDPOINT_INVITATIONS_LIST, ENDPOINT_INVITATIONS_SEND_REMINDER, ENDPOINT_INVITATIONS_SEND_REMINDER_ALL, ENDPOINT_INVITATIONS_SET_AUTO_REMINDER } from '../Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckDouble, faCog, faExclamationTriangle, faInfoCircle, faShare, faSync, faVideo } from '@fortawesome/free-solid-svg-icons';
import InvitationAction from '../components/InvitationAction';
import DateField from '../components/DateField';
import { format } from 'date-fns';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import useProps from '../hooks/useProps';
import { useParams } from 'react-router-dom';

const Invitations = () => {
    const { groupId } = useParams();
    usePageTitle('Invitations');
    const { props } = useProps();
    const [loading, setLoading] = useState(false);
    const [speakersWrapper, setSpeakersWrapper] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [reminderError, setReminderError] = useState(null);
    const [frequencyStatus, setFrequencyStatus] = useState(null);
    const [autoRemindFrequencyTime, setِAutoRemindFrequencyTime] = useState(0);
    const [invitations, setInvitations] = useState(null);
    const axiosPrivate = useAxiosPrivate();
    const envAutoRemindFrequencies = process.env.REACT_APP_INVITATION_AUTO_REMIND_FREQUENCIES || '';
    const autoRemindFrequencies = envAutoRemindFrequencies.split(',');

    const loadInvitations = async () => {
        try {
            setLoading(true);
            const response = await axiosPrivate.get(ENDPOINT_INVITATIONS_LIST.replace('{groupId}', groupId));
            setSpeakersWrapper(response.data);
            setِAutoRemindFrequencyTime(response.data.autoRemindFrequencyTime);
            setInvitations(response.data.invitations);
            if (response.data.autoRemindEndDate) {
                setEndDate(response.data.autoRemindEndDate);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const dateFormat = (date) => {
        if (!date)
            return '';
        return format(new Date(date), process.env.REACT_APP_INVITATION_DATE_FORMAT)
    }

    useEffect(() => {
        loadInvitations();
    }, []);

    const handleAutoReminder = async () => {
        setFrequencyStatus('Saving');
        setReminderError(null);
        try {
            const response = await axiosPrivate.post(ENDPOINT_INVITATIONS_SET_AUTO_REMINDER.replace('{groupId}', groupId), {
                frequencyTime: autoRemindFrequencyTime,
                ...(endDate && { autoReminderEndDate: format(new Date(endDate), "MMM dd, yyyy hh:mm:ss a") })
            });
            if (response.status === 200) {
                setFrequencyStatus('Saved');
                loadInvitations();
            }
        } catch (error) {
            setFrequencyStatus('Error');
            setReminderError(error?.response?.data?.data)
        } finally {
            setTimeout(() => {
                setFrequencyStatus(null);
            }, 1200);
        }
    };

    const handleInvitationUpdate = (invitation) => {
        setInvitations(prevItems =>
            prevItems.map(item =>
                item.id === invitation.id ? invitation : item
            ));
    }

    return (
        <div>
            {loading ?
                <div className="spinner-grow">
                    <span className="visually-hidden">Loading...</span>
                </div>
                :
                <>
                    {invitations ?
                        <div>
                            <div className='d-flex justify-content-between'>
                                <h5 className='align-self-end'>
                                    Invitations Sent <span className='text-primary'>{speakersWrapper.totalInvitationCount}</span>
                                </h5>
                                <div className='d-flex flex-row gap-3 align-items-center'>
                                    <div className="dropdown">
                                        <div className="btn-group">
                                            <button type="button" className="btn btn-primary" disabled><FontAwesomeIcon icon={faClock} fixedWidth /> Auto-reminder is {speakersWrapper.autoRemindStatus}</button>
                                            <div className='dropdown-menu dropdown-menu-end p-0' style={{ width: '325px' }}>
                                                <div className="list-group list-group-flush rounded">
                                                    {speakersWrapper.autoRemindEndDate &&
                                                        <div className='list-group-item'>
                                                            <label className='form-label'>A reminder will be sent after:</label>
                                                            <select className='form-control form-control-sm' value={autoRemindFrequencyTime} onChange={(e) => { setِAutoRemindFrequencyTime(e.target.value) }}>
                                                                {autoRemindFrequencies.map((option, index) => {
                                                                    const [label, value] = option.split('=');
                                                                    return (
                                                                        <option key={index} value={value}>
                                                                            {label}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                            <span className='small'>From the invitation date <span className='text-muted small'>(Maximum {speakersWrapper.invitationReminderMaxCount} reminders)</span></span>
                                                        </div>
                                                    }
                                                    <div className='list-group-item'>
                                                        <label className='form-label'>Reminders End Date</label>
                                                        <div>
                                                            <DateField initialDate={endDate} inputClasses='form-control-sm' required={true} onDateChange={(date) => { setEndDate(date) }} />
                                                        </div>
                                                        {reminderError &&
                                                            <div className='text-danger small'>{reminderError}</div>
                                                        }
                                                    </div>
                                                    <div className='list-group-item text-end bg-light'>
                                                        {frequencyStatus &&
                                                            <span className={frequencyStatus === 'Saved' ? 'text-success' : frequencyStatus === 'Error' ? 'text-danger' : ''}>
                                                                <FontAwesomeIcon icon={frequencyStatus === 'Saving' ? faSync : frequencyStatus === 'Saved' ? faCheck : frequencyStatus === 'Error' ? faExclamationTriangle : ''} spin={frequencyStatus === 'Saving'} fixedWidth className='me-1' />
                                                                {frequencyStatus}
                                                            </span>
                                                        }
                                                        {!frequencyStatus &&
                                                            <button type='button' className='btn btn-sm btn-outline-primary px-4' style={{ zIndex: 0 }} onClick={handleAutoReminder}>Save</button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="button" className="btn btn-primary dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                <FontAwesomeIcon icon={faCog} fixedWidth />
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <button type="button" className="btn btn-outline-dark" data-bs-toggle="modal" data-bs-target="#reminderModal">
                                            <FontAwesomeIcon icon={faInfoCircle} fixedWidth />
                                        </button>
                                        <div className="modal fade" id="reminderModal">
                                            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h1 className="modal-title fs-5" id="exampleModalLabel">Streamlining Event {props.speaker} Video Submissions with Automated Reminders</h1>
                                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <p>Efficiently managing event {props.speaker} video recordings is crucial to the success of your event. Our automated reminder system ensures that the process remains seamless and on track, putting you in control every step of the way. Here's how it works:</p>
                                                        <ol>
                                                            <li><strong>Encouraging Timely Video Submissions:</strong> Our system triggers reminders when a {props.speaker} has not yet completed their video recording. This proactive approach helps {props.speaker}s fulfill their commitments promptly.</li>
                                                            <li><strong>Respecting Individual Preferences:</strong> We understand the importance of personalization. Through the exclusive 'Do not send reminders' button, event administrators have the power to deliberately exempt specific invitations from receiving automated reminders. This ensures that your communication is tailored to each {props.speaker}'s unique circumstances.</li>
                                                            <li><strong>Balanced Reminder Frequency:</strong> The system maintains a balance by sending up to a maximum of {speakersWrapper.invitationReminderMaxCount} automatic reminders. This prevents overloading {props.speaker}s with excessive notifications, promoting a positive engagement experience.</li>
                                                            <li><strong>Aligned with Schedule:</strong> Rest assured, no automatic reminders will be sent once the provided end date for reminders has passed. This feature guarantees that reminders remain relevant and timely.</li>
                                                        </ol>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <InvitationAction endPoint={ENDPOINT_INVITATIONS_SEND_REMINDER_ALL} text='Remind All' doneText='Reminders Sent' btnClasses='btn btn-primary text-nowrap' /> */}
                                </div>
                            </div>
                            <hr />
                            <table className="table table-striped table-sm table-borderless">
                                <thead>
                                    <tr className='table-stat-head-sub'>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Email</th>
                                        <th className='d-none'>Phone</th>
                                        <th>Status</th>
                                        <th>Invited On</th>
                                        <th>Remind Count</th>
                                        <th>Last Reminded On</th>
                                        {speakersWrapper.autoRemindFrequencyTime > 0 &&
                                            <th>Next Reminder On</th>
                                        }
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invitations && invitations.map((invitation, idx) =>
                                        <tr key={idx}>
                                            <td className='text-sp-dark'>{invitation.firstName}</td>
                                            <td className='text-sp-dark'>{invitation.lastName}</td>
                                            <td className='text-sp-dark'>{invitation.email}</td>
                                            <td className='text-sp-dark d-none'>{invitation.phone}</td>
                                            <td className='text-sp-dark'>
                                                <span className="badge text-bg-light">
                                                    <FontAwesomeIcon icon={invitation.status === 'Sent' ? faCheck : invitation.status === 'Opened' ? faCheckDouble : invitation.status === 'Recorded' ? faVideo : invitation.status === 'Shared' ? faShare : ''} fixedWidth></FontAwesomeIcon> {invitation.status}
                                                </span>
                                            </td>
                                            <td className='text-sp-dark'>{dateFormat(invitation.invitedOn)}</td>
                                            <td className='text-sp-dark text-center'>{invitation.remindsCount}</td>
                                            <td className='text-sp-dark'>{dateFormat(invitation.remindedOn)}</td>
                                            {speakersWrapper.autoRemindFrequencyTime > 0 &&
                                                <td className='text-sp-dark'>{(invitation.status === 'Sent' || invitation.status === 'Opened') && invitation.autoReminderExcludedDate ? 'Auto-reminder disabled' : dateFormat(invitation.furtherAutoReminderOn)}</td>
                                            }
                                            <td width='15%'>
                                                {(invitation.status === 'Sent' || invitation.status === 'Opened') &&
                                                    <div className='vstack gap-1 float-end'>
                                                        <InvitationAction invitationId={invitation.id} endPoint={ENDPOINT_INVITATIONS_SEND_REMINDER.replace('{groupId}', groupId)} text='Send Reminder' doneText='Reminder Sent' btnClasses='btn-sm btn-outline-primary'
                                                            onSuccess={(response) => {
                                                                handleInvitationUpdate(response.data);
                                                            }}
                                                        />
                                                        {!invitation.autReminderExcludedDate && speakersWrapper.autoRemindFrequencyTime > 0 && invitation.furtherAutoReminderOn &&
                                                            <InvitationAction invitationId={invitation.id} endPoint={ENDPOINT_INVITATIONS_EXCLUDE_REMINDER.replace('{groupId}', groupId)} text='Do not send reminders' doneText='Auto-reminder disabled' btnClasses='btn-sm btn-outline-primary'
                                                                onSuccess={(response) => {
                                                                    handleInvitationUpdate(response.data);
                                                                }} />
                                                        }
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div >
                        :
                        <>
                            <div className='alert alert-warning'>
                                No {props.speaker}(s) added yet.
                            </div>
                        </>
                    }
                </>

            }
        </div>
    )
}

export default Invitations
